module.exports = __webpack_public_path__ + "img/5.0a49f572.svg";